import React from 'react';
import './App.scss';
import { About, Footer, Header, Skills, Testimonial, Work } from './container';
import { ContactUs } from './container/Footer/ContactUs';
import { Navbar } from './components';
import Services from './container/Services/Services';

const App = () => {
  return (
    <div className="app">
      <Navbar />
      <Header />
      {/* <Services /> */}
      <Work />
      <About />
      <Skills />
      <Footer />
      {/* <ContactUs /> */}
    </div>
  );
};

export default App;
